
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Check } from "lucide-react";

interface VerificationActionsProps {
  onResend: () => void;
  onVerify: () => void;
  isVerifying: boolean;
  canVerify: boolean;
}

export function VerificationActions({ onResend, onVerify, isVerifying, canVerify }: VerificationActionsProps) {
  return (
    <div className="flex gap-2 w-full">
      <Button
        variant="outline"
        onClick={onResend}
        className="flex-1"
      >
        Resend code
      </Button>
      <Button 
        onClick={onVerify} 
        disabled={isVerifying || !canVerify}
        className="flex-1"
      >
        {isVerifying ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Verifying...
          </>
        ) : (
          <>
            <Check className="mr-2 h-4 w-4" />
            Verify
          </>
        )}
      </Button>
    </div>
  );
}
